import { useEffect } from 'react';
import { getShapeDrawingUrls } from '../config/drawings';

// 形状変更の3ステップ（誤り・中間・モチーフ）のデッサン画像を用意して onImagesReady で返す。
// 画像は事前生成した public/dessin/ のもの（正本は config/drawings.js）。
// 以前は隠しキャンバスで描画し Flask の /reverse でエッジ化していたが、呼び出し側との
// 取り決め（errorGlbPath を受け取り、URL 3つの配列を返す）はそのまま残している。
function DrawingPrepare({ errorGlbPath, onImagesReady }) {
  useEffect(() => {
    if (!errorGlbPath) return;
    onImagesReady(getShapeDrawingUrls(errorGlbPath));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorGlbPath]);

  return null;
}

export default DrawingPrepare;
